import MaintenanceImage from '@assets/images/Maintenance.png'
import MediaImage from '@components/MediaImage'
import { envConfig } from '@globals/env'
import AnonPaths from '@globals/paths/anon'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PageKudosTitleImage from '@shared/PageKudosTitleImage'
import { StackStyles } from '@shared/routing/RoutingStyles'
import { T, useT } from '@transifex/react'
import { Navigate } from 'react-router'
import useApiStatus from './useApiStatus'

const MaintenanceRoute: React.FC = () => {
  const t = useT()
  const { isHealthy } = useApiStatus()

  if (isHealthy) {
    return <Navigate to={AnonPaths.userLogin()} />
  }
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      useFlexGap
      gap={3}
      p={2}
      sx={StackStyles}>
      <PageKudosTitleImage />
      <Typography variant="h1">
        <T _str="We’ll be right back!" />
      </Typography>
      <Typography variant="body1" textAlign="center">
        <T _str="We’re currently performing maintenance to improve your experience" />
      </Typography>
      <MediaImage
        alt={t('maintenance image')}
        imgSrc={MaintenanceImage}
        maxWidth={320}
        maxHeight={320}
        backgroundColor="transparent"
      />
      <Typography variant="body1">
        <T _str="For real-time updates" />
      </Typography>
      <Button
        id="checkStatusBtn"
        variant="contained"
        href={envConfig.MAINTENANCE_STATUS_PAGE_URL}
        fullWidth
        sx={{ mt: 0, maxWidth: 344 }}>
        <T _str="Check status page" />
      </Button>
    </Stack>
  )
}

export default MaintenanceRoute
